<template>
    <div class="background-update">
        <div class="content">
            <v-img width="200px" class="img-update" contain :src="require('@/assets/img/img-placeholder.png')"/>
            <div class="text-update">
                {{ $t('common.new_version_available') }}
            </div>
            <v-btn @click="goToStore" class="normal-btn black--text" depressed color="primary" large>
                {{ $t('common.download') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: "UpdateApp",
    computed: {
        url() {
            return process.env.VUE_APP_PLAYSTORE_URL || null
        },
    },
    methods: {
        goToStore() {
            const vm = this
            window.open(vm.url)
        }
    }
}
</script>

<style scoped>
.background-update {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--v-backGroundPrimary-base);
    height: 100%;
    width: 100%;
    color: #FFFFFF;
}

.content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.img-update {
    border-radius: 12px;
    border: 1px solid #FFFFFF;
}

.text-update {
    margin: 12px 0;
    font-size: 18px;
}

</style>
